import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule} from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ngxTranslateConfig } from './config/translate.config';
import { ngxUiLoaderConfig, ngxUiLoaderHttpConfig  } from './config/ui-loader.config';
import { AuthenticationService } from './core/authentication.service';
import { CanActivateAuthGuard } from './core/can-activate-auth.guard';
import { LoginAuthGuard } from './core/login-auth.guard';
import { TokenInterceptor } from './core/token.interceptor';
import { UserFactory } from './core/user.factory';
import { NotificationService } from './services/notification.service';
import { ErrorInterceptor } from './core/error.interceptor';
import { TranstationFactory } from './core/translation.factory';
import {NgIdleKeepaliveModule} from "@ng-idle/keepalive";
import {MomentModule} from "angular2-moment";
import { CookieService } from "angular2-cookie/services/cookies.service";
import { UtilityService } from './services/utility.service';
import { DateDifferenceService } from './shared/display/date-difference.service';
import { SharedModule } from './shared/shared.module';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot(ngxTranslateConfig ),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot(ngxUiLoaderHttpConfig),
    SlickCarouselModule,
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    SharedModule,
    // app modules
    AppRoutingModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    NotificationService,
    AuthenticationService,
    UserFactory,
    CanActivateAuthGuard,
    LoginAuthGuard,
    TranstationFactory,
    CookieService,
    UtilityService,
    DateDifferenceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
